import React from "react";
import { motion } from "framer-motion";
import constants from "./../../../constants";
import styles from "./OfficeOptions.module.scss";
import { Link } from "react-router-dom";

const Card = ({
  to,
  icon,
  title,
  officeName,
  redirectTo,
  designation,
  locationState = {},
  isDisabled = false,
  setIsSubscriptionModel = () => {},
}) => {
  if (redirectTo) {
    return (
      <motion.div
        whileHover={{ scale: constants.animation.hoverScale }}
        whileTap={{ scale: constants.animation.hoverScale }}
      >
        <span
          onClick={isDisabled ? () => setIsSubscriptionModel(true) : redirectTo}
          className={isDisabled ? "disabled" : "pointer"}
        >
          <div className={styles["card"]}>
            <img className={`${styles["icon"]} mr-2`} src={icon} alt="icon" />
            <h4>{title}</h4>
          </div>
        </span>
      </motion.div>
    );
  }
  return (
    <motion.div
      whileHover={{ scale: constants.animation.hoverScale }}
      whileTap={{ scale: constants.animation.hoverScale }}
    >
      <Link
        to={
          isDisabled
            ? "#"
            : {
                pathname: to,
                state: { officeName, designation, ...locationState },
              }
        }
        onClick={(e) => {
          if (isDisabled) {
            e.preventDefault();
            setIsSubscriptionModel(true);
          }
        }}
        className="text-decoration-none"
      >
        <div
          className={`${styles["card"]} ${
            isDisabled ? styles["disabled"] : ""
          }`}
        >
          <img className={`${styles["icon"]} mr-2`} src={icon} alt="icon" />
          <h4>{title}</h4>
        </div>
      </Link>
    </motion.div>
  );
};

export default Card; // Correct the export statement here
